import { Tag } from 'antd'

import { ParticipateType } from '../../../../../../enums/ParticipateType'
import {
  PriceCompareMemberPageStatus,
  PriceCompareMemberPageStatusColorMap,
  PriceCompareMemberPageStatusEntrustTextMap,
  PriceCompareMemberPageStatusParticipantTextMap
} from '../../../enums/PriceCompareMemberPageStatus'

import { PriceCompareListStatusRenderProps } from './interface'

export const PriceCompareListStatusRender = ({
  record: { status = PriceCompareMemberPageStatus.WAIT_AUDIT, participateType }
}: PriceCompareListStatusRenderProps) => {
  const PriceCompareMemberStatusTextMap =
    participateType === ParticipateType.ENTRUST
      ? PriceCompareMemberPageStatusEntrustTextMap
      : PriceCompareMemberPageStatusParticipantTextMap

  return (
    <Tag color={PriceCompareMemberPageStatusColorMap[status]} variant='filled'>
      {PriceCompareMemberStatusTextMap[status]}
    </Tag>
  )
}
